<div class="select-calendar-event-header">
  <h1 class="terra-title" data-cy="select-calendar-event-dialog_title">Select calendar event</h1>
  <ninety-button
    data-cy="select-calendar-event-dialog_close-button"
    flat
    icon
    ariaLabel="Close dialog"
    (click)="cancel()">
    <terra-icon icon="x" />
  </ninety-button>
</div>
<p class="text-light select-calendar-event-subtitle">{{ subtitle() }}</p>

@if (calendarService().loading()) {
  <p data-cy="select-calendar-event-dialog_loading">Loading events for {{ rangeLabel() }}...</p>
} @else if (calendarService().error()) {
  <p data-cy="select-calendar-event-dialog_error">Couldn't load your calendar events. Try again later.</p>
} @else if (visibleEvents().length === 0) {
  <p data-cy="select-calendar-event-dialog_empty">No events found on your calendar for {{ rangeLabel() }}.</p>
} @else {
  <div class="event-list" data-cy="select-calendar-event-dialog_event-list">
    @for (event of visibleEvents(); track event.id) {
      <div
        class="event-item"
        [class.disabled]="!getMeetingPlatform(event.meetingUrl) || hasEnded(event)"
        [class.selected]="event.id === selectedEventId()"
        (click)="select(event)"
        attr.data-cy="select-calendar-event-dialog_event-{{ event.id }}">
        <terra-icon icon="calendar" size="20" />
        <div class="event-item-copy">
          <span class="event-summary">{{ event.summary }}</span>
          @if (hasEnded(event)) {
            <span class="text-light">This event has ended</span>
          } @else if (!event.meetingUrl) {
            <span class="text-light">No conference link found</span>
          }
        </div>
        @if (event.start) {
          <span class="text-light event-time">{{ event.start | date: 'MMM d, y h:mm a' }}</span>
        }
      </div>
    }
  </div>
}
